import React, { useState, useEffect } from "react";
import { setUserData, resetUserState } from "../redux/userRedux/userActions";
import { resetCart } from "../redux/reducers/cartActions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/img/Logo.png";
import Image from "../assets/img/hambLogin.png";
import instanceAPI from "../api/axios.service.js";
import "../styles/Form.css";
import { loginRouterService } from "../services/login.router.service";
import { Link } from "react-router-dom";
import { swalAlertDanger } from "../components/common/Alerts";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Limpiar el estado del usuario y carrito al montar el componente
  useEffect(() => {
    dispatch(resetUserState());
    dispatch(resetCart());
  }, [dispatch]);

  const apiURL = process.env.REACT_APP_API_URL;

  const handleLogin = async (data) => {
    setLoading(true);
    try {
      const res = await instanceAPI.post("/login", data);
      setLoading(false);
      if (res.data.success) {
        // Limpiar el carrito al iniciar sesión
        dispatch(resetCart());
        // Establecer los datos del usuario
        dispatch(setUserData(res.data.user));
        const route = await loginRouterService(res.data.user);
        navigate(route);
      } else {
        if (res.status === 402) {
          swalAlertDanger(
            "Error de autenticación",
            res.data.message || "Credenciales inválidas",
            () => {}
          );
        }
      }
    } catch (error) {
      setLoading(false);
      swalAlertDanger(
        "Error de autenticación",
        "Credenciales inválidas",
        () => {}
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin({ email, password });
  };

  return (
    <div className="login-container">
      <Link to="/">
        <img src={Logo} alt="logo" className="login-logo" />
      </Link>
      <div className="login-header">
        <p className="login-welcome-text">
          <span>¡Bienvenido!</span> Llego la <br />
          hora de hacer tu pedido.
        </p>
        <img src={Image} alt="burger" className="login-image" />
      </div>
      <form onSubmit={handleSubmit} className="login-form">
        <input
          type="email"
          placeholder="Correo electrónico(E-mail)"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="login-input"
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="login-input login-input-password"
        />
        <div className="forgot-password">
          ¿Olvidaste tu contraseña?{" "}
          <span onClick={() => navigate("/recover-password")}>
            ¡Recupérala aquí!
          </span>
        </div>
       
        
        <div className="login-buttons">
          <button
            type="button"
            onClick={() => window.open(`${apiURL}/auth/google`, "_self")}
            className="google-button"
          >
            <img
              src="https://developers.google.com/identity/images/g-logo.png"
              alt="Google Login"
              className="google-logo"
            />
            <span className="google-button-text">Iniciar sesión con Google</span>
          </button>
          <button
            type="submit"
            disabled={loading}
            className="login-submit-button"
            style={{
              opacity: loading ? 0.6 : 1,
              cursor: loading ? "not-allowed" : "pointer"
            }}
          >
            {loading ? "Cargando..." : "Iniciar sesión"}
          </button>
        </div>
      </form>
      <div className="register-link">
        ¿No estás registrado?{" "}
        <button type="button" onClick={() => navigate("/register")}>
          ¡Regístrate aquí!
        </button>
      </div>
    </div>
  );
}

export default Login;
